import { useNavigate } from 'react-router-dom';
import { Icon } from '../../../layout/Icon.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { formatIQD, formatDate } from '../../../shared/format.js';

function StatusPill({ status }) {
  if (status === 'posted') return <Pill variant="success">مرحّلة</Pill>;
  if (status === 'cancelled') return <Pill variant="danger">ملغاة</Pill>;
  return <Pill variant="warning">مسودّة</Pill>;
}

// حالة السداد مشتقّة من المبالغ على الخادم — تُعرض بجانب حالة الفاتورة
// حتى يرى المستخدم «مسددة جزئياً» دون فتح الفاتورة.
function PaymentPill({ invoice }) {
  const st = invoice.paymentStatus;
  if (!st || invoice.status === 'draft') return null;
  if (st === 'paid') return <Pill variant="success">مسددة بالكامل</Pill>;
  if (st === 'partial') return <Pill variant="warning">مسددة جزئياً</Pill>;
  if (st === 'cancelled') return null;
  return <Pill variant="danger">غير مسددة</Pill>;
}

export function PurchaseRow({ invoice, canEdit, canPost, onPost, onCancel, onDelete }) {
  const navigate = useNavigate();
  const id = invoice._id || invoice.id;
  const date = invoice.date ? formatDate(invoice.date) : '—';

  return (
    <tr className="border-b border-line hover:bg-paper-2">
      <td className="p-2.5 font-bold" style={{ fontFamily: 'monospace' }}>{invoice.number}</td>
      <td className="p-2.5">{invoice.supplierId?.name || '—'}</td>
      <td className="p-2.5">{invoice.warehouseId?.name || '—'}</td>
      <td className="p-2.5 text-ink-2">{date}</td>
      <td className="p-2.5">{invoice.items?.length || 0}</td>
      <td className="p-2.5 font-bold">{formatIQD(invoice.total)}</td>
      <td className="p-2.5 text-[#15803D]">{formatIQD(invoice.paid)}</td>
      <td className="p-2.5 text-[#B91C1C]">{formatIQD(invoice.due)}</td>
      <td className="p-2.5">
        <div className="flex gap-1 flex-wrap">
          <StatusPill status={invoice.status} />
          <PaymentPill invoice={invoice} />
        </div>
      </td>
      <td className="p-2.5">
        <div className="flex gap-1 justify-end">
          <button
            type="button"
            className="btn"
            style={{ padding: '4px 8px' }}
            onClick={() => navigate(`/purchase/${id}`)}
            title="عرض / تعديل"
          >
            <Icon name="edit" size={13} />
          </button>
          {canPost && invoice.status === 'draft' ? (
            <button
              type="button"
              className="btn btn-success"
              style={{ padding: '4px 8px' }}
              onClick={() => onPost(invoice)}
              title="ترحيل"
            >
              <Icon name="check" size={13} />
            </button>
          ) : null}
          {canPost && invoice.status === 'posted' ? (
            <button
              type="button"
              className="btn"
              style={{ padding: '4px 8px', color: '#B91C1C' }}
              onClick={() => onCancel(invoice)}
              title="إلغاء فاتورة"
            >
              <Icon name="x" size={13} />
            </button>
          ) : null}
          {canEdit && invoice.status === 'draft' ? (
            <button
              type="button"
              className="btn"
              style={{ padding: '4px 8px', color: '#B91C1C' }}
              onClick={() => onDelete(invoice)}
              title="حذف"
            >
              <Icon name="trash" size={13} />
            </button>
          ) : null}
        </div>
      </td>
    </tr>
  );
}
